import { Radio } from "@base-ui/react/radio";
import { RadioGroup } from "@base-ui/react/radio-group";
import { Controller, useFormContext } from "react-hook-form";
import ExtendedImage from "@/components/ui/extended-image";
import type { Question } from "@/types/content";

const MultiSelectQuestion = ({ question }: { question: Question }) => {
  const { control } = useFormContext();
  return (
    <div className="flex flex-col gap-4">
      <div className="relative w-full aspect-video">
        <ExtendedImage
          alt={question.id}
          className="rounded-2xl max-h-96 aspect-video"
          fill={true}
          src={question.image}
        />
      </div>
      <p className="leading-5 font-medium">{question.text}</p>
      <Controller
        control={control}
        defaultValue=""
        name={question.id}
        render={({ field }) => {
          return (
            <RadioGroup
              aria-labelledby={question.id}
              className="flex flex-col items-start gap-1"
              onValueChange={(value) => {
                field.onChange(value);
              }}
              value={field.value}
            >
              {question.options.map((option) => (
                <label
                  className="flex items-center justify-between border border-gray-300 rounded-xl px-4 py-2 w-full gap-2"
                  htmlFor={option.id}
                  key={option.id}
                >
                  {option.label}
                  <Radio.Root
                    className="flex size-5 items-center justify-center rounded-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 data-checked:bg-white data-checked:border data-checked:border-brand-blue-600 data-unchecked:border data-unchecked:border-gray-300"
                    id={option.id}
                    value={option.id}
                  >
                    <Radio.Indicator className="flex before:size-3 before:rounded-full before:bg-brand-blue-600 data-unchecked:hidden" />
                  </Radio.Root>
                </label>
              ))}
            </RadioGroup>
          );
        }}
      />
    </div>
  );
};

export default MultiSelectQuestion;
